import "./style.scss";
const Footer = () => {
  return (
    <div className="container">
      <footer className="footer">
        Made by Nhat Tin -
        <span>
          Github:{" "}
          <a href="https://github.com/tinnhat/nt-shop" target="_blank">
            NT-Shop
          </a>{" "}
        </span>
      </footer>
    </div>
  );
};
export default Footer;
